export default function cesuCodeValidation(code) {
  if (code) {
    return code.length >= 26;
  }
  return false;
}
